module.exports = __webpack_public_path__ + "static/media/polaroid-7.98080ce6.png";